import { render, staticRenderFns } from "./BargainSettings.vue?vue&type=template&id=a5a8bef8&scoped=true"
import script from "./BargainSettings.vue?vue&type=script&lang=js"
export * from "./BargainSettings.vue?vue&type=script&lang=js"
import style0 from "./BargainSettings.vue?vue&type=style&index=0&id=a5a8bef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a8bef8",
  null
  
)

export default component.exports